import React from 'react'
import { Grid } from 'styled-css-grid'
import cn from 'classnames'

function Container({ columns, editable, textDirection, className, children }) {
  let gridColumns = ['minmax(100px, 3fr)']
  gridColumns.push(...Array(columns.length).fill('1fr'))

  if (editable) {
    gridColumns = ['24px', ...gridColumns]
  }

  return (
    <Grid
      columns={gridColumns.join(' ')}
      dir={textDirection}
      className={cn('width full', className)}
      columnGap='0'
    >
      {children}
    </Grid>
  )
}

export default Container
